import { render, staticRenderFns } from "./LoadingView.vue?vue&type=template&id=1499d2e2"
import script from "./LoadingView.vue?vue&type=script&lang=ts"
export * from "./LoadingView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports